module.exports = __webpack_public_path__ + "media/react/marketing/pages/gre/plans/sections/hero/assets/video_lessons_icon-652801ea8bf06aa796b39bef8702a649.svg";